import { MailDelivery } from '../types/mail';

export const MAX_MAIL_COPIES = 5;

const ZIP_REGEX = /^(([0-9]{5})|([0-9]{5}-[0-9]{4}))$/;

/** Shared so a publisher-configured address is held to the same rule as a customer's. */
export function getMailDeliveryValidationError(
  recipient: MailDelivery
): string {
  if (!recipient.name) {
    return 'Recipient name is missing';
  }
  if (recipient.name.length > 40) {
    return 'Recipient name must be less than 40 characters';
  }
  if (!recipient.address?.address_line1) {
    return 'Address line 1 is missing';
  }
  if (!recipient.copies) {
    return 'Number of copies is missing';
  }
  if (recipient.copies > MAX_MAIL_COPIES || recipient.copies < 1) {
    return 'Mailing must have between one and five copies';
  }
  if (!recipient.address.address_city) {
    return 'City is missing';
  }
  if (!recipient.address.address_state) {
    return 'State is missing';
  }
  if (!recipient.address.address_zip) {
    return 'Zip code is missing';
  }
  if (!`${recipient.address.address_zip}`.match(ZIP_REGEX)) {
    return 'Zip code is invalid';
  }
  return '';
}
